import styled from "styled-components";

export const StyledOrderList = styled.div`
  padding: 100px 0% 100px 5.5%;
  display: flex;
  background: #fff;

  .order-skeleton {
    margin-top: 30px;
    width: 45%;
  }

  .customer-name {
    color: ${(props) => props.primary_color};
    font-weight: 700;
    font-size: 20px;
    margin: 10px 0px;
  }

  .order-wrapper {
    width: 50%;
    float: left;
    .return-container {
      width: 90%;
      .return-box {
        width: 48%;
        padding: 1rem;
        margin: 10px 0px;
        cursor: pointer;
        border: 1px solid #c7D4E4;

        div {
          display: flex;
          align-items: center;
        }
        .return-reference-id {
          margin-right: 4px;
          padding: 4px;
          font-size: 16px;
          padding-left: 0px;
          color: #3B444D;
          font-weight: 700;
        }

        .return-status-label {
          background: #DCF6DD;
          color: #19811C;
          font-size: 14px;
          padding: 5px 10px;
          margin-top: 0px;
          white-space: nowrap;
          max-width: 175px;
          font-weight: 400;
          text-overflow: ellipsis;
          display: inline-block;
          overflow: hidden;
        }

        .return-product-image {
          margin-right: 10px;
          height: 100%;
          max-height: 50px;
          object-fit: cover;
        }
      }
    }
  }

  .select-order-heading {
    display: flex;
    justify-content: space-between;
    width: 90%;
  }

  .more-orders-web, .more-orders-mobile {
    text-decoration: underline;
    color: ${(props) => props.primary_color};
    font-size: 16px;
    cursor: pointer;
    width: fit-content;
    font-weight: 700;
  }

  .more-orders-mobile {
    display: none;
  }

  .return-for {
    color: #3B444D;
    font-size: 1rem;
    margin: 6px 0px;
  }

  .single-request-notice {
    width: 90%;
    margin: 12px 0;
    padding: 12px 14px;
    border: 1px solid #f59e0b;
    border-left: 5px solid #d97706;
    background: #fffbeb;
    color: #78350f;
    font-size: 15px;
    font-weight: 600;
    line-height: 1.5;
  }

  .return-policy {
    margin: 15px 0px;
    color: #3B444D;
    font-size: 16px;
  }

  .selected {
    border: 1px solid #111111 !important;
    background: #f5f5f5;
  }

  @media (max-width: 800px) {
    padding: 70px 0px 0px;
    justify-content: center;

    .order-skeleton {
      margin-top: 10px;
      width: 90%;
    }

    .customer-name {
      font-size: 20px;
      margin: 0px;
      padding: 0 15px;
    }

    .order-wrapper {
      width: 100%;
      display: ${(props) =>
    props.selectedOrder !== undefined && props.selectedOrder.length > 0
      ? "none"
      : "block"};
      .return-container {
        width: 100%;
        .return-box {
          width: 100%;
          margin: 10px 15px 0px !important;
          background: #fff;
          .return-reference-id {
            font-weight: 400;
          }
        }
      }
    }

    .select-order-heading {
      width: 100%;
      margin-top: 10px;
    }

    .more-orders-mobile {
      display: block;
      margin-top: 10px;
    }
    
    .more-orders-web {
      display: none;
    }

    .return-for {
      font-size: 16px;
      padding: 0 15px;
    }

    .single-request-notice {
      width: auto;
      margin: 12px 15px;
      font-size: 14px;
    }

    .return-policy {
      font-size: 16px;
      padding: 0 15px;
    }

    .more-orders-mobile,
    .more-orders-web,
    .help,
    .retry,
    .search-container,
    .search-field {
      padding: 0 15px;
    }
  }
`;

export const StyledOrderBox = styled.div`
  padding: 0.5rem 0.5rem 0.5rem 1rem;
  border-bottom: 1px solid rgba(17, 17, 17, 0.2);
  margin: 0px;
  width: 90%;
  background: ${(props) => (props.eligible ? "#fff" : "rgba(0,0,0,0.1)")};
  cursor: ${(props) => (props.eligible ? "pointer" : "not-allowed")};
  position: relative;
  display: flex;
  flex-direction: column;
  justify-content: center;

  :hover {
    background: ${(props) =>
    props.eligible ? `${props.primary_color}11` : "rgba(0,0,0,0.1)"};

    .right-icon {
      color: ${(props) => props.primary_color};
      fill: ${(props) => props.primary_color};
    }
  }

  .right-icon {
    margin-left: auto;
    font-size: 24px;
  }

  .order-number {
    font-size: 20px;
    color: #3B444D;
    font-weight: 700;
  }

  .order-created, .order-delivered {
    font-size: 16px;
    color: #3B444D;
    font-weight: 400;
  }

  .order-dates {
    display: flex;
    align-items: center;
    margin-top: 5px;
  }

  @media (max-width: 800px) {
    margin: 0px;
    padding: 1rem;
    width: 100%;

    .order-number {
      font-sizee: 20px;
    }
    
    .order-dates {
      flex-direction: column;
      align-items: start;
    }
  }
`;

export const StyledAddress = styled.div`
  .address-skeleton {
    margin-top: 220px;
    width: 100%;
    min-width: 300px;
  }

  @media (min-width: 800px) {
    padding: 0px 40px;
    width: 50%;
    float: right;
  }
`;
